<template>
  <base-setting-widget :iteminfo="iteminfo" v-bind="$attrs" v-on="$listeners">
    <div style="min-height: 100px">
      <div class=" flex a-top">
        <div class="fs-14 redsuffix fs-s-0">商品描述</div>
        <div class="flex-1 clearfix m-l-10">
          <!--show-word-limit-->
          <Input :autosize="{minRows: 1,maxRows: 3}" :border="false" class="w-full b-b inputBoder" maxlength="64"
                 placeholder="请输入标题"
                 style="font-size: 12px;color: blue;float: left;"
                 type="textarea"
                 v-model="iteminfo.config.title"/>
        </div>
      </div>
      <div class=" flex a-center m-t-20">
        <div class="fs-14 fs-s-0">商品价格</div>
        <div class="flex-1 clearfix m-l-10 b-b inputnumberboder">
          <input-number :border="false" :min="0"
                        class="w-full "
                        placeholder="商品价格"
                        style="font-size: 12px;color: blue;float: left;"
                        v-model="iteminfo.config.price">
            <template #append>
              <span class="p-h-5">元</span>
            </template>
          </input-number>
        </div>
      </div>

      <div
        class="w-full m-b-10 flex m-v-10"
      >
        <span class="fs-14  w-90">轮播方式：</span>
        <RadioGroup class="w-full flex" v-model="iteminfo.config.autoPlay">
          <radio :label="0" size="small" class="m-r-10">
            <span class="fs-14 ">自动轮播</span>
          </radio>
          <radio :label="1" size="small" class="m-r-10">
            <span class="fs-14 ">手动轮播</span>
          </radio>
        </RadioGroup>
      </div>

      <ul class="w-full h-full m-t-15 clearfix" style="margin-left: -7px;margin-right: -7px">
        <li class="clearfix m-7" style="float: left;height:106px;width: 106px">
          <div @click="onPicChooseClick" class="w-full  h-full flex a-center j-center" style="background: #F8F8F9;">
            <div class="flex-column a-center">
              <img alt="" class="w-full h-full" src="../../../assets/common/img_addzhutu.png">
            </div>
          </div>
        </li>
        <!--<li class="clearfix" style="float: left">-->
        <!--<file-type-upload :uploadType="7" @uploadStart="onUploadStart" @uploadSuccess="uploadSuccess" class="m-7"-->
        <!--multiple prefix="goods/goods/"-->
        <!--style="height:106px;width: 106px" videoprefix="goods/goods/">-->
        <!--<div class="w-full h-full" slot="tip">-->
        <!--<div class="w-full  h-full flex a-center j-center" style="background: #F8F8F9;">-->
        <!--<div class="flex-column a-center">-->
        <!--<img alt="" class="w-full h-full" src="../../../assets/common/img_addzhutu.png">-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</file-type-upload>-->
        <!--</li>-->
        <draggable
          @end="isDragging=false"
          @start="isDragging=true"
          class="list-group"
          element="ul"
          v-bind="dragOptions"
          v-model="iteminfo.config.coverList"
        >
          <li :key="index" class="relative m-7 Imgbox clearfix"
              style="height:106px;width: 106px; float: left" v-for="(item,index) in iteminfo.config.coverList">
            <img :src="getShowImg(item)" alt="" class="w-full h-full" style="border-radius: 4px;"
                 v-if="item.fileType === 1 && (item.progress === 0 || item.progress === 100)">
            <div class="w-full h-full relative"
                 v-if="item.fileType === 2 && (item.progress === 0 || item.progress === 100)">
              <img :src="getShowVideo(item)" class="w-full h-full"
                   style="border-radius: 4px;object-fit: fill"></img>
              <div class="absolute top-0 left-0 flex a-center j-center"
                   style="background: #00000040;height:107px;width: 107px">
                <img src="../../../assets/common/ic_shipin_play.png" style="width: 50px;height: 50px;">
              </div>
            </div>
            <div class="absolute top-0 left-0 flex a-center j-center"
                 style="background: #00000040;height:106px;width: 106px"
                 v-if="item.progress>0 && item.progress<100">
              <Progress :percent="item.progress" class="p-h-10 w-full"/>
            </div>
            <img @click="onItemDelClick(item,index)"
                 alt="" class="picImgHover"
                 src="../../../assets/common/ic_yichu.png"
                 style="position: absolute;right: -11px;top: -11px;cursor: pointer">
          </li>
        </draggable>
      </ul>
    </div>
    <source-choose-widget :chooseType="3" @ok="onSourceChoose" multiple ref="srcChoose">

    </source-choose-widget>
  </base-setting-widget>
</template>

<script>
import BaseSettingWidget from '../base/BaseSettingWidget'
import FileTypeUpload from '../../common/FileTypeUpload'
import draggable from 'vuedraggable'
import SourceChooseWidget from '../../source/SourceChooseWidget'


export default {
  name: 'ProductInfoSettingWidget',
  components: {SourceChooseWidget, FileTypeUpload, BaseSettingWidget, draggable},
  props: {
    iteminfo: {
      type: Object,
      default: () => {
        return {
          config: {
            datalist: [],
            price: '',
            title: '',
            specification: '',
            classify: '',
            grouping: '',
            menuList: []
          }
        }
      }
    }
  },
  data () {
    return {
      isDragging: false,
    }
  },
  computed: {
    getpiclist () {
      if (this.iteminfo.config.coverList) {
        return this.iteminfo.config.coverList
      } else {
        return []
      }
    },
    dragOptions () {
      return {
        animation: 0,
        group: 'adesc',
        // handle: '.my-handle',
        ghostClass: 'ghost',
      }
    },
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },

    onUploadStart (data) {
      if (data && data.length) {
        let piclist = data
        // let length = this.iteminfo.config.coverList.length || 0
        // let num = 6 - length
        // if (num > 0) {
        //   piclist = piclist.slice(0, num)
        // } else {
        //   this.$Message.info('最多上传6张')
        //   return
        // }
        this.iteminfo.config.coverList = this.iteminfo.config.coverList.concat(piclist)
      }
    },
    uploadSuccess (data) {
      if (data && data.length) {

      }
    },
    getShowImg (item) {
      return item.localUrl || item.imgUrl || item.url
    },
    getShowVideo (item) {
      return item.imgUrl || (item.videoUrl + '?x-oss-process=video/snapshot,t_1000,f_png,w_0,h_0')
    },
    //清除该图片数据
    onItemDelClick (item, index) {
      this.iteminfo.config.coverList.splice(index, 1)
    },
    onPicChooseClick () {
      this.$refs.srcChoose.show()
    },
    onSourceChoose (data, next) {
      if (data && data.length) {
        console.log('selectList', data)
        let piclist = data.map(res => {
          return {
            fileType: res.type,
            height: res.height,
            id: 0,
            progress: 100,
            title: res.title,
            imgUrl: res.type === 1 ? res.url : res.coverImgUrl,
            videoUrl: res.sourceUrl || '',
            width: res.width,
            imgMaterialId: res.type === 1 ? res.imgId : 0,
            videoMaterialId: res.type === 2 ? res.videoId : 0,
          }
        })
        this.iteminfo.config.coverList = this.iteminfo.config.coverList.concat(piclist)
      }
      next()
    },
  }
}
</script>

<style scoped>
  .inputnumberboder >>> .ivu-input-number {
    border: none;
    padding: 0;
  }

  .inputnumberboder >>> .ivu-input-number-focused {
    box-shadow: none;
    outline: none;
  }
</style>
